<template lang="html">
  <div class="">
    <div class="container">
      <!-- <div class="h3">单集</div> -->
      <el-table
        border
        stripe
        v-loading="tableDataLoading"
        :data="tableData"
        :lazy="true"
        load="loadEpisodesSold"
        style="width: 100%">
        <el-table-column
          prop="id"
          label="编号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="title"
          label="单集标题">
        </el-table-column>
        <el-table-column
          prop="created"
          label="创建时间"
          width="230"
          :formatter="createdFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="sold.sold_count"
          label="销量"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="sold.revenue_yuan"
          fixed="right"
          label="金额 (元)"
          width="120">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="handleCurrentChange"
          :total="totalCounts">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableDataLoading: true,
        tableData: [],
        totalCounts: 0,
        syncFeedLoading: false,
        syncFeedDisabled: false,
        sold: {
          revenue_yuan: 100
        }
      }
    },
    methods: {
      getEpisodes (offset) {
        let that = this
        let params = {
          offset: offset,
          slug: that.$route.params.slug,
          includeDraft: true
        }
        that.$api.episode.list(params).then(res => {
          window.console.log(res)
          that.tableData = res.data.results
          that.totalCounts = res.data.count
          that.tableDataLoading = false
        })
      },
      handleClick(row) {
        window.console.log(row);
      },
      handleCurrentChange(val) {
        window.console.log(`当前页: ${val}`)
        this.getEpisodes(val * 10 - 10)
      },
      createdFormatter (row, column, cellValue, index) {
        // window.console.log("创建时间格式化：")
        // window.console.log(row)
        // window.console.log(column)
        // window.console.log(cellValue)
        window.console.log(index)
        let date = new Date(parseInt(cellValue)*1000)
        date = date.getFullYear() + "年" + (date.getMonth() + 1) + "月" + date.getDate() + '日'
        // let date = new Date(
        //   parseInt(cellValue)*1000).toLocaleDateString()
        let time = new Date(
          parseInt(cellValue)*1000).toLocaleTimeString()
        return `${date}${time}`
      },
      // sellCount (row, column, cellValue, index) {
      //   let that = this
      //   window.console.log(row)
      //   window.console.log(column)
      //   window.console.log(cellValue)
      //   window.console.log(index)
      //   let episodeId = cellValue
      //   that.$api.episode.sold(episodeId).then(res => {
      //     // window.console.log(res)
      //     window.console.log(`${episodeId}的销售量：`)
      //     window.console.log(res.data.order_success_count)
      //     return res.data.order_success_count
      //   })
      //   return 0
      // },
      // loadEpisodesSold (row, treeNode, resolve) {
      //   window.console.log(">>>>>>>")
      //   window.console.log(row)
      //   window.console.log(treeNode)
      //   window.console.log(resolve)
      //   window.console.log("<<<<<<<")
      //   return 1
      // }
    },
    mounted () {
      let offset = 0
      this.getEpisodes(offset)
    }
  }
</script>

<style lang="css" scoped>
  .pagination {
    width: 100%;
    margin-top: 15px;
    text-align: center;
  }
  .grid-content {
      margin-bottom:15px;
    display: flex;
  }
  .item {
    margin-right: 10px;
  }
</style>
